import { ethers } from "ethers";
import contractAbi from '../contractAbi/mint.json'
import store from '@/store'
import wallet from "../wallet"
const BSC_CONFIG = wallet.BSC_CONFIG
const CURRENT_NETWORK = wallet.CURRENT_NETWORK
const RPC = BSC_CONFIG[CURRENT_NETWORK].rpcUrl
const contractAddress = BSC_CONFIG[CURRENT_NETWORK].mintAddress

export async function getOTMPrice() {
  const provider = new ethers.providers.JsonRpcProvider(RPC)
  const contract = new ethers.Contract(contractAddress, contractAbi, provider);
  const price = await contract.getOTMPrice();
  return ethers.utils.formatUnits(price, 18)
}

export async function inviterMap() {
  const provider = new ethers.providers.JsonRpcProvider(RPC)
  const address = store.state.walletAddress
  const contract = new ethers.Contract(contractAddress, contractAbi, provider);
  const refAddress = await contract.inviterMap(address);
  return refAddress
}

export async function mint(type, _amount, inviter) {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const contract = new ethers.Contract(contractAddress, contractAbi, provider);
  const mintSigner = contract.connect(signer)
  // console.log('parseUnits(amount)', parseUnits(amount.toString()))
  const tx = await mintSigner.mint(type, _amount.toString(), inviter)
  const waitRes = await tx.wait()
  return waitRes
}

export async function getMAX_AMOUNT() {
  const provider = new ethers.providers.JsonRpcProvider(RPC)
  const contract = new ethers.Contract(contractAddress, contractAbi, provider);
  const amount = await contract.MAX_AMOUNT();
  return amount
}

export async function getLEFT_AMOUNT() {
  const provider = new ethers.providers.JsonRpcProvider(RPC)
  const contract = new ethers.Contract(contractAddress, contractAbi, provider);
  const amount = await contract.LEFT_AMOUNT();
  return amount
}

export async function getSignData(msg) {
  const provider = new ethers.providers.Web3Provider(window.ethereum)
  const signer = provider.getSigner()
  const signature = await signer.signMessage(msg);
  return signature
}